module.exports = "dist/ef4a9f280b0e411ddf6c930a0a37c2b0.ttf";